import React, { useState } from "react";
import { Button, ConfirmationModal, Modal } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation } from "react-query";
import { realignSchedules } from "../../api/adminService";
import styles from "./DepositRecordBackfill.module.css";
export var ScheduleRealignPanel = function () {
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var _a = useState(false), showConfirm = _a[0], setShowConfirm = _a[1];
    var realignMutation = useMutation(function () { return realignSchedules(kyInstance); });
    var running = realignMutation.isLoading;
    var result = realignMutation.data;
    var error = realignMutation.error
        ? realignMutation.error instanceof Error
            ? realignMutation.error.message
            : formatMessage({
                id: "ui-br-legaldeposits.admin.realignSchedules.error",
            })
        : null;
    var run = function () {
        setShowConfirm(false);
        realignMutation.mutate();
    };
    return (React.createElement("div", { className: styles.container, "data-test-id": "schedule-realign-panel" },
        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.admin.realignSchedules.title", tagName: "h2" }),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.admin.realignSchedules.description" })),
        React.createElement("div", null,
            React.createElement(Button, { buttonStyle: "primary", onClick: function () { return setShowConfirm(true); }, disabled: running, "data-test-id": "schedule-realign-trigger" }, running ? (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.admin.realignSchedules.button.running" })) : (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.admin.realignSchedules.button.start" })))),
        result && (React.createElement("div", { className: styles.result, "data-test-id": "schedule-realign-result" },
            React.createElement("div", { className: styles.statsGrid },
                React.createElement("div", { className: styles.statItem },
                    React.createElement("span", { className: styles.statLabel },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.admin.realignSchedules.stats.processed" }),
                        ":"),
                    React.createElement("span", { "data-test-id": "schedule-realign-processed" }, result.processed)),
                React.createElement("div", { className: styles.statItem },
                    React.createElement("span", { className: styles.statLabel },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.admin.realignSchedules.stats.changed" }),
                        ":"),
                    React.createElement("span", { "data-test-id": "schedule-realign-changed" }, result.changed))))),
        error && (React.createElement(Modal, { label: React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.admin.realignSchedules.error.title" }), open: true, onClose: function () { return realignMutation.reset(); }, dismissible: true }, error)),
        React.createElement(ConfirmationModal, { open: showConfirm, heading: formatMessage({
                id: "ui-br-legaldeposits.admin.realignSchedules.confirm.heading",
            }), message: formatMessage({
                id: "ui-br-legaldeposits.admin.realignSchedules.confirm.message",
            }), onConfirm: run, onCancel: function () { return setShowConfirm(false); }, confirmLabel: formatMessage({
                id: "ui-br-legaldeposits.admin.realignSchedules.button.start",
            }) })));
};
